module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmarks-5ed1723d.svg";